"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Option_1 = require("fp-ts/lib/Option");
var Either_1 = require("fp-ts/lib/Either");
var LocalStorageUtils;
(function (LocalStorageUtils) {
    LocalStorageUtils.getItem = function (key) {
        try {
            return Option_1.fromNullable(localStorage.getItem(key)).chain(function (value) {
                return Option_1.some(JSON.parse(value));
            });
        }
        catch (e) {
            return Option_1.none;
        }
    };
    LocalStorageUtils.setItem = function (key) { return function (value) {
        try {
            var data = JSON.stringify(value);
            localStorage.setItem(key, data);
            return Either_1.right(value);
        }
        catch (e) {
            return Either_1.left(e);
        }
    }; };
    LocalStorageUtils.removeItem = function (key) { return localStorage.removeItem(key); };
})(LocalStorageUtils = exports.LocalStorageUtils || (exports.LocalStorageUtils = {}));
